"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = void 0;
var _styledSystem = require("styled-system");
const appearances = (0, _styledSystem.variant)({
  prop: 'variant',
  scale: 'typography.variants'
});
const fontStyles = (0, _styledSystem.variant)({
  prop: 'fontStyle',
  scale: 'typography.fontStyle'
});
const variants = exports.variants = {
  appearances,
  fontStyles
};